import {storiesAdapter} from "../slices/stories";

export const {
    selectById: storyById,
    selectAll: storiesAll,
} = storiesAdapter.getSelectors((state: any)=> state.stories);
